module.exports = __webpack_public_path__ + "assets/img/integral.1a1d9e15.svg";